<div class="custom-modal-layout">
  <div class="modal-header">
    <div class="icon">
      <img src="icons/plus-circle.svg" alt="Email Icon" />
    </div>
    <span class="title">Novo auxílio de formação</span>
    <p-button icon="pi pi-times" class="close-btn" [rounded]="true" [text]="true" (onClick)="cancel()" />
  </div>
  <form [formGroup]="institutionForm" (ngSubmit)="save()">

    <div class="p-fluid grid">

      <div class="col-12 mb-3">
        <label for="numeroDoBI">Número Bilhete de Identidade</label>
        <div class="flex align-items-center">
          <input id="numeroDoBI" type="search" class="w-full" pInputText formControlName="numeroDoBI"
            placeholder="Informe o número do BI" />
          <button pButton type="button" icon="pi pi-search" class="ml-2" (click)="searchDocumentNumber()"
            aria-label="Search"></button>
        </div>
      </div>

      <div class="col-12">
        <label for="nome">Nome do estudante</label>
        <input id="nome" type="text" class="w-full" pInputText formControlName="nome" placeholder="Nome do estudante" />
      </div>

      <div class="col-6">
        <label for="dataNascimento">Data de Nascimento</label>
        <p-datepicker id="dataNascimento" class="w-full d-grid" [showIcon]="true"
          placeholder="Seleccione a data de nascimento" formControlName="dataNascimento" dateFormat="dd/mm/yy"/>
        <div
          *ngIf="institutionForm.controls['dataNascimento'].hasError('idadeMinima') && institutionForm.controls['dataNascimento'].touched">
          <small class="p-error">O estudante deve ser maior que 15 anos.</small>
        </div>
      </div>

      <div class="field col-6">
        <label for="endereco">Endereço</label>
        <input id="endereco" type="text" class="w-full" pInputText formControlName="endereco" placeholder="Endereço" />
      </div>

      <div class="col-6">
        <label for="estadoCivil">Estado Civil</label>
        <p-dropdown id="estadoCivil" [filter]="true" class="w-full" [options]="estadoCivilOptions" optionLabel="label"
          optionValue="id" placeholder="Seleccione o estado civil" formControlName="estadoCivil" />
      </div>

      <div class="col-6">
        <label for="genero">Gênero</label>
        <p-dropdown id="genero" class="w-full" [filter]="true" [options]="generoOptions" optionLabel="label"
          optionValue="id" placeholder="Seleccione o gênero" formControlName="genero" />
      </div>

      <div class="col-6">
        <label for="instituicaoEnsinoID">Instituição de Ensino</label>
        <p-dropdown [filter]="true" appendTo="body" id="instituicaoEnsinoID" [options]="educationalInstitution"
          optionLabel="nome" optionValue="id" placeholder="Seleccione uma instituição de curso" class="w-full"
          (onChange)="onInstitutionChange($event)"></p-dropdown>
      </div>

      <div class="col-6">
        <label for="instituicacoCursoID">Instituição do Curso</label>
        <p-dropdown [filter]="true" appendTo="body" id="instituicacoCursoID" formControlName="instituicacoCursoID"
          [options]="instituicaoCursoList" optionLabel="nome" optionValue="id"
          placeholder="Seleccione uma instituição de curso" class="w-full"></p-dropdown>
      </div>

      <div class="col-12">
        <label for="tipoBolsaID">Tipo de Bolsa</label>
        <p-dropdown [filter]="true" appendTo="body" id="tipoBolsaID" formControlName="tipoBolsaID" [options]="tipoBolsa"
          optionLabel="nome" optionValue="id" placeholder="Seleccione um tipo de auxílios de formação"
          class="w-full"></p-dropdown>
      </div>

      <div class="col-12">
        <label for="instituicaoGestoraID">Instituição Gestora</label>
        <p-dropdown [filter]="true" appendTo="body" id="instituicaoGestoraID" formControlName="instituicaoGestoraID"
          [options]="instituicaoGestora" optionLabel="nome" optionValue="id"
          placeholder="Seleccione uma instituição gestora" class="w-full"></p-dropdown>
      </div>

      <div class="col-6">
        <label for="estadoBolsa">Estado da Bolsa</label>
        <p-dropdown [filter]="true" appendTo="body" id="estadoBolsa" formControlName="estadoBolsa"
          [options]="[{label: 'Activa', value: '1'}, {label: 'Inactiva', value: '2'}]" placeholder="Seleccione um estado"
          class="w-full"></p-dropdown>
      </div>

      <div class="col-6 flex flex-column">
        <label for="anoLectivoInicio">Ano Lectivo Início</label>
        <p-calendar class="d-contents" appendTo="body" id="anoLectivoInicio" formControlName="anoLectivoInicio"
          view="year" dateFormat="yy" yearNavigator="true" [yearRange]="'2000:2030'"></p-calendar>
      </div>

      <div class="col-6 flex flex-column">
        <label for="anoLectivoFim">Ano Lectivo Fim</label>
        <p-calendar class="d-contents" appendTo="body" id="anoLectivoFim" formControlName="anoLectivoFim" view="year"
          dateFormat="yy" yearNavigator="true" [yearRange]="'2000:2030'"></p-calendar>
      </div>

      <div class="col-6">
        <label for="idEstadoMatricula">Estado da Matrícula</label>
        <p-dropdown [filter]="true" appendTo="body" id="idEstadoMatricula" formControlName="idEstadoMatricula"
          [options]="[{label: 'Matriculado', value: '1'}, {label: 'Não Matriculado', value: '2'}]"
          placeholder="Seleccione um estado" class="w-full"></p-dropdown>
      </div>
    </div>

    <div *ngIf="institutionForm.hasError('dateRange')" class="error-message">
      Data de término não pode ser anterior à data de início
    </div>

    <div class="modal-footer">
      <button pButton type="button" label="Cancelar" class="p-button-outlined" (click)="cancel()"></button>
      <button pButton type="submit" label="Guardar" class="p-button-primary"></button>
    </div>
  </form>
</div>
<p-toast></p-toast>
